import type { WorkoutRewardConfig } from './progression';

export const challengeTypes = ['daily_500', 'daily_250', 'daily_250_gold', 'daily_200', 'daily_100', 'daily_50'] as const;
export type ChallengeType = typeof challengeTypes[number];

export interface ChallengeDetails extends WorkoutRewardConfig {
  title: string;
  goalPointsPerUser: number;
  durationMs: number;
  durationLabel: string;
  expiredLabel: string;
  ctaLabel: string;
}

export const challengeConfig: Record<ChallengeType, ChallengeDetails> = {
  daily_500: {
    title: 'Daily 500 Point Challenge',
    goalPointsPerUser: 500,
    durationMs: 24 * 60 * 60 * 1000,
    durationLabel: '24 Hours',
    expiredLabel: 'This workout has ended after 24 hours. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'conditional',
    talentReward: 1,
    goldReward: 500,
  },
  daily_50: {
    title: 'Daily 50 Point Challenge',
    goalPointsPerUser: 50,
    durationMs: 60 * 60 * 1000,
    durationLabel: '1 Hour',
    expiredLabel: 'This workout has ended after 1 hour. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'conditional',
    talentReward: 0.1,
    goldReward: 50,
  },
  daily_250: {
    title: 'Daily 250 Point Challenge',
    goalPointsPerUser: 250,
    durationMs: 24 * 60 * 60 * 1000,
    durationLabel: '24 Hours',
    expiredLabel: 'This workout has ended after 24 hours. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'conditional',
    talentReward: 0.5,
    goldReward: 250,
  },
  daily_250_gold: {
    title: 'Daily 250 Point Gold Challenge',
    goalPointsPerUser: 250,
    durationMs: 24 * 60 * 60 * 1000,
    durationLabel: '24 Hours',
    expiredLabel: 'This workout has ended after 24 hours. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'talent-and-gold',
    talentReward: 0.1,
    goldReward: 250,
  },
  daily_200: {
    title: 'Daily 200 Point Gold Challenge',
    goalPointsPerUser: 200,
    durationMs: 2 * 60 * 60 * 1000,
    durationLabel: '2 Hours',
    expiredLabel: 'This workout has ended after 2 hours. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'gold-only',
    talentReward: 0,
    goldReward: 350,
  },
  daily_100: {
    title: 'Daily 100 Point Challenge',
    goalPointsPerUser: 100,
    durationMs: 24 * 60 * 60 * 1000,
    durationLabel: '24 Hours',
    expiredLabel: 'This workout has ended after 24 hours. Create a new daily workout to keep going.',
    ctaLabel: 'Create',
    rewardMode: 'conditional',
    talentReward: 0.1,
    goldReward: 100,
  },
};

export function isChallengeType(value: unknown): value is ChallengeType {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(challengeConfig, value);
}
